import {
    apiRequest,
    Create,
    CreateDetail,
    Submit
} from "../../../../../services/adapters/kepegawaian/mutasiPegawaiService"

class IndexRepository { 

    fetchCreate = async (query, cancelToken) => {
        return await apiRequest("post", Create, {
            body: query
        }, true)
    }

    fetchCreateDetail = async (query, cancelToken) => {
        return await apiRequest("post", CreateDetail, {
            body: query
        }, true)
    }

    fetchSubmit = async (query) => {
        return await apiRequest("post", Submit, {
            body: query
        }, true)
    }

}

export default IndexRepository;